import { Alert } from 'antd';
import React from 'react';
import { ValidationError } from '../../types/api-response.types';
import { useTranslation } from 'react-i18next';

interface ValidationErrorsPreviewProps {
  validationErrors: ValidationError[];
  entity: string;
}

const ValidationErrorsPreview = ({ validationErrors, entity }: ValidationErrorsPreviewProps) => {
  const { t } = useTranslation();
  return (
    <Alert
      message={t('crud.create.error', { entity })}
      description={
        <ul style={{ paddingLeft: 20, margin: 0 }}>
          {validationErrors.map((error) => (
            <li key={error.path}>
              <strong>{error.path}</strong>: {error.message}
            </li>
          ))}
        </ul>
      }
      type="error"
      showIcon
    />
  );
};

export default ValidationErrorsPreview;
